var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.localExtras = {
	toggleCategoryFormFieldVisibility: function() {
		var $layoutSelect = $('#layout');
		var $layoutSelectValue = $layoutSelect.val();
		var $dishPrice = $('#elm_dishPrice');
		var $soupPrice = $('#elm_soupPrice');
		var $soupSaladPrice = $('#elm_soupSaladPrice');
		var $allPrice = $('#elm_allPrice');

		if ($layoutSelectValue === 'lunchmenu') {
			$dishPrice.show();
			$soupPrice.show();
			$soupSaladPrice.show();
			$allPrice.show();
		} else {
			$dishPrice.hide();
			$soupPrice.hide();
			$soupSaladPrice.hide();
			$allPrice.hide();
		}

		$layoutSelect.unbind().on('change', function() {
			site.localExtras.toggleCategoryFormFieldVisibility();
		});
	},
	toggleItemFormFieldVisibility: function() {
		var $isPizza = document.getElementById('ispizza');

		if($isPizza) {
			var $price = $('#elm_text1');
			var $price2 = $('#elm_text2');
			var $price3 = $('#elm_text3');


			if ($isPizza.checked) {
				$price.hide();
				$price2.show();
				$price3.show();
			} else {
				$price.show();
				$price2.hide();
				$price3.hide();
			}

			$isPizza.addEventListener('change', function() {
				site.localExtras.toggleItemFormFieldVisibility();
			});
		}
	}
};

site.menu = {
	tabs: function(selector) {
		var $tabs = $(selector);
		$tabs.tabs({
			activate: function( event, ui ) {
				var $accordion = $(event.target).closest('section');
				var height = $('.content.ui-tabs', $accordion).outerHeight(true);
				$('> .wrap', $accordion).removeAttr('style').css('max-height', height);
			}
		});
		$tabs.removeClass('ui-widget ui-widget-content ui-corner-all');
		$('.ui-tabs-nav', selector).removeClass('ui-widget-header ui-corner-all');
		$('.ui-tabs-nav > li', selector).removeClass('ui-state-default ui-corner-top');
		$('.ui-widget-content', selector).removeClass('ui-widget-content ui-corner-bottom');
	}
};

site.lunchMenu = {
	init: function(selector, data){
		if (selector && data) {
			$('.lunchMenu').css('background-image', 'url(' + data + ')');
		}
	},
};

site.frontpage = {
	init: function() {
		$('a.scroll[href^=#]').on('click', function() {
			var target = $(this.hash);
			target = target.length ? target : $('[id=' + this.hash.slice(1) +']');
			if (target.length) {
				var offset = $('body').width() < 768 ? 35 : 0;
				$('html,body').animate({
					scrollTop: target.offset().top - offset
				}, 1000);
				return false;
			}
		});

		site.frontpage.animation();
	},

	animation: function() {
		//Banner background load
		$('#hero-banner .index2 .img').bgLoaded();

		//APP
		var $app = $('.box.app_ad_box .contentWrap');
		$app.css('opacity', 0).addClass('animated');

		$app.waypoint(function() {
			$app.removeAttr('style');
			$app.addClass('fadeInUp');
		}, { offset: '80%' });
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	if ($body.is('.extras') && $body.is('.admin')) {
		site.localExtras.toggleCategoryFormFieldVisibility();
		site.localExtras.toggleItemFormFieldVisibility();
	}

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
